const getEndpointApiUrl = (server) => {
  switch (server) {
  case 'production':
    return 'https://mezzo-api.nesscs.com'
  case 'smartlink':
    return 'https://smartlink-api.nesscs.com'
  case 'validation':
    return 'https://valid-api.nesscs.com'
  default:
    return null
  }
}


export default getEndpointApiUrl
